import { get, isMatch } from 'lodash';

type Item = {};

const isLikelyToBeRootPerAction = (action: string | undefined) =>
  // Node action (from the prefill)
  action === 'folder' || action === 'folderList' || action === 'directory';

const isLikelyGoogleDriveRoot = (item: Item) =>
  isMatch(item, { id: 'root', title: 'root' });

const isLikelyDropboxRoot = (item: Item) => isMatch(item, { path: '/' });

const isLikelyBoxRoot = (item: Item, index: number) =>
  isMatch(item, { type: 'folder' }) &&
  !get(item, 'name', '').includes('/') &&
  index === 0;

const isLikelyOneDriveRoot = (item: Item) =>
  isMatch(item, { _path: '', name: '/' });

export default function isPrefillChoiceRoot(
  action: string | undefined,
  item: Item,
  index: number
) {
  return (
    isLikelyToBeRootPerAction(action) &&
    (isLikelyGoogleDriveRoot(item) ||
      isLikelyDropboxRoot(item) ||
      isLikelyBoxRoot(item, index) ||
      isLikelyOneDriveRoot(item))
  );
}
